var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('feather-icon',{attrs:{"icon":"CircleIcon","svgClasses":['fill-current h-4 w-4', _vm.textColor]}})}
var staticRenderFns = []

export { render, staticRenderFns }